<template>
  <div>
    <div id="leaflet-map"></div>
  </div>
</template>

<script>

import {api} from '../../../store/api';

export default {
  name: 'app-location-map',
  data() {
    return {
      locationMap: null,
      masterplanResources: null,
      masterplanConfig: null,
      lotconfig: null,
      masterplanBounds: null,
      masterLayer: null,
      lotGeo: null,
      lotfeature: null,
      lotgeojsons: null,
      sub: null,
    }
  },
  props: {
    lotId: String
  },
  created() {
  },
  mounted: function () {
    this.fetchGeoJsonLots();
  },
  destroyed() {
    this.sub();
  },
  methods: {
    fetchGeoJsonLots: function () {
      api.fetchLotGeojson().then((res) => {
        this.lotgeojsons = res.data;
        this.getMapsConfig();
      })
    },
    getMapsConfig: function () {

        this.sub = this.$store.subscribe((mutation, state) => {
          if (mutation.type === 'setMasterplanConfig') {
            this.masterplanConfig = state.communityStore.masterplanConfig;
            this.initLocationMap();
          }
        })
        this.$store.dispatch('fetchMasterplanConfig');
    },

    initLocationMap: function () {
      if (!this.locationMap) {
        const mastererLayer = this.masterplanConfig.svgFileConfigs.find(item => {
          return (item.svgFileType.fileType.toLowerCase() === 'master' || item.svgFileType.label.toLowerCase() === 'master')
        });
        if (mastererLayer) {
          const corner1 = L.latLng(mastererLayer.neLatBound, mastererLayer.neLongBound);
          const corner2 = L.latLng(mastererLayer.swLatBound, mastererLayer.swLongBound);
          this.masterplanBounds = L.latLngBounds(corner1, corner2);
        }

        this.locationMap = L.map('leaflet-map', {
          center: this.masterplanBounds.getCenter(),
          minZoom: 14,
          zoom: 18,
          maxZoom: 20,
          maxBounds: this.masterplanBounds
        });

        L.tileLayer(mastererLayer.baseLayerUrl + '/{z}/{x}/{y}.png', {
          maxZoom: 21,
        }).addTo(this.locationMap);

        this.addDetailLayer(mastererLayer);
      }

      this.zoomToLot();
    },


    zoomToLot: function () {
      if (this.lotfeature) {
        this.locationMap.removeLayer(this.lotfeature);
      }

      this.lotgeojsons = this.lotgeojsons.geoJson;

      const geojson = {
        type: 'FeatureCollection',
        features: []
      };
      const feature = this.lotgeojsons.features.find(item => item.properties.lotCpId === this.lotId);
      if (feature) {
        geojson.features.push(feature);
      }

      this.lotGeo = geojson;
      this.lotfeature = L.geoJSON(this.lotGeo, {
        style: {
          fillColor: "#ff7800",
          fillOpacity: '0.6',
          weight: '1',
        }
      }).addTo(this.locationMap);

      this.locationMap.flyToBounds(this.lotfeature.getBounds(), {padding: [200, 200]});
      this.initMasonry();
    },

    addDetailLayer: function (layer) {
      this.locationMap.createPane('detailPane');
      this.locationMap.getPane('detailPane').style.zIndex = 500;
      L.tileLayer(layer.detailLayerUrl + '/{z}/{x}/{y}.png', {
        pane: 'detailPane',
        maxZoom: 21,
        detectRetina: true,
        errorTileUrl: '',
        transparent: true,
      }).addTo(this.locationMap);
    },

    initMasonry: function () {
      $('#masonry-boxes').imagesLoaded(function () {
        $('#masonry-boxes').masonry({
          itemSelector: '.grid-box',
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/package/LocationMap.vue